import type { ReducedMotionMode } from '../config/types';

/** Resolve whether motion should be reduced, honoring config and the OS setting for `auto`. */
export function prefersReducedMotion(mode: ReducedMotionMode): boolean {
  if (mode === 'always') return true;
  if (mode === 'never') return false;
  return typeof matchMedia === 'function' && matchMedia('(prefers-reduced-motion: reduce)').matches;
}
